import { styleConstants } from '@paywithextend/components'
import { Location } from 'history'
import React from 'react'
import Lnk from 'src/navigation/Lnk'
import { LocationState } from 'src/redux/createRootReducer'
import { css, keyframes } from 'styled-components'

type ObjectTableBodyRowProps =
  | ObjectTableBodyRowPropsAriaSource
  | ObjectTableBodyRowPropsAriaLabel

interface ObjectTableBodyRowPropsShared {
  className?: string
  to?: Location<LocationState> | string
  onClick?: () => void
  noLeftPadding?: boolean
  testId?: string
}

interface ObjectTableBodyRowPropsAriaSource
  extends ObjectTableBodyRowPropsShared {
  ariaLabelSource: string
  ariaLabel?: undefined
}

interface ObjectTableBodyRowPropsAriaLabel
  extends ObjectTableBodyRowPropsShared {
  ariaLabel: string
  ariaLabelSource?: undefined
}

const ObjectTableBodyRow: React.FC<
  React.PropsWithChildren<ObjectTableBodyRowProps>
> = (props): React.ReactElement => {
  const sharedStyling = css`
    position: relative;
    display: table-row;
    padding: 0px ${styleConstants.widths.cardPaddingXSMUp};
  `

  const slideAnimation = keyframes`
    0%   { transform: translateX(0px)  }
    25%  { transform: translateX(4px)  }
    50%  { transform: translateX(0px)  }
    75%  { transform: translateX(-4px) }
    100% { transform: translateX(0px)  }
  `

  const { testId } = props

  return props.to === undefined ? (
    <div
      className={props.className}
      onClick={props.onClick}
      onKeyPress={props.onClick}
      role="button"
      tabIndex={0}
      data-testid={testId}
      css={css`
        ${sharedStyling}
        ${!!props.noLeftPadding &&
        css`
          padding: 0px;
        `}
      `}
    >
      {props.children}
    </div>
  ) : (
    <Lnk
      to={props.to}
      className={props.className}
      {...(props.ariaLabelSource !== undefined
        ? { ariaLabelSource: props.ariaLabelSource }
        : { ariaLabel: props.ariaLabel })}
      onClick={props.onClick}
      testId={testId}
      css={css`
        ${sharedStyling}
        cursor: pointer;

        &:hover {
          background-color: ${styleConstants.colors.blue_opacity};

          .animated-table-chevron {
            animation-name: ${slideAnimation};
            animation-duration: 1s;
            animation-iteration-count: infinite;
            animation-direction: normal;
            animation-timing-function: linear;
            animation-fill-mode: none;
          }
        }
      `}
    >
      {props.children}
    </Lnk>
  )
}

export default ObjectTableBodyRow
